// src/app/core/ui-redirect.ts
export function redirectToRightApp(isNewUI: boolean) {
  const AS  = document.location.protocol + "//" + document.location.hostname + ":" + document.location.port + '/AutomationStudio';
  const SUB = document.location.protocol + "//" + document.location.hostname + ":" + document.location.port + '/HuLoopSubscriptionUI';
  const suffix = window.location.hash && window.location.hash !== '#'
    ? window.location.hash
    : (isNewUI ? '#/login' : '#/login');

  const targetBase = isNewUI ? AS : SUB;
  const target = targetBase;

  const href = window.location.href;
  const onAS  = href.includes('/AutomationStudio/');
  const onSUB = href.includes('/HuLoopSubscriptionUI/');
  const alreadyCorrect = (isNewUI && onAS) || (!isNewUI && onSUB);

  if (!alreadyCorrect) {
    window.location.replace(target);
  }
}
